import { map, mapValues, pickBy } from 'lodash-es';

export function queryBuilder(strings: Array<string>, ...params: Array<Record<string, string | number | null | undefined>>): string {
  const paramsMapped = params.map(param => map(pickBy(param, value => value !== null && value !== undefined), (value, key) => {
    const escaped = String(value).replace('"', '\\"');
    return `${key}="${escaped}"`;
  }).join(', '));

  return strings.reduce((result, string, index) => result + string + (paramsMapped[index] || ''), '');
}

export function parametrizeQuery(query: ((...args: Array<unknown>) => string) | string, ...params: Array<unknown>): string {
  let res = '';
  if (typeof query === 'function') {
    res = query(...params);
  }

  return res || query as string;
}

export function parametrizeQueryPack(pack: Record<string, (params: any) => string>, ...params: Array<unknown>): Record<string, string> {
  return mapValues(pack, query => parametrizeQuery(query, ...params));
}
